<template>
  <section class="section" style="margin-top: -40px;">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            ອອກຕະຫຼາດ
          </h2>
        </div>
      </div>
      
      <b-tabs v-model="activeTab" v-if="roleid == 30 || roleid == 31" style="margin-top: -20px;">


        
            <b-tab-item label="ຜູ້ຈັດຊື້ຕະຫຼາດສົດ">
              <b-field style="font-size: 16px; margin-bottom: 40px;" v-if="roleid == 30">
                ຟອມເຕີມເງິນ
              </b-field>
              <b-field grouped style="margin-top: -30px;" v-if="roleid == 30"> 
                <b-field style="width: 200px;"> 
                  <Multiselect
                    placeholder="ເລືອກຜູ້ຮັບຜິດຊອບ"  
                    v-model.trim="selectedPurchaser"
                    label="NAME"
                    track-by="ID"
                    :options="purchaserBalanceList"
                  >
                  </Multiselect>
                </b-field>
              
                <b-field>
                  <b-input 
                    v-model.trim="selectedAmount"
                    type="number"  
                    min="0"
                    pattern="[0-9]+"
                    class="text-right-input"
                    placeholder="ຈຳນວນເງິນ"
                    style="width: 200px;text-align: right;"
                  >
                  </b-input>
                
                </b-field>
                <b-field>
                  <b-input 
                    v-model.trim="selectedRemark"
                    type="text"  
                    placeholder="ເນື້ອໃນ"
                    style="width: 400px;text-align: right;"
                  >  
                  </b-input>
                
                </b-field>
                <b-field>
                  <b-button style="margin-top: 0px;"
                    class="btn-group-margin"
                    type="is-primary"
                    @click="topupMoney"
                    >ບັນທຶກ
                  </b-button>
                
                </b-field>
              </b-field>
              <b-field style="margin-top: 30px;">
                ຜູ້ຈັດຊື້ຕະຫຼາດສົດ
              </b-field>
              <table class="table is-fullwidth is-narrow is-small">
                <thead>
                  <tr>
                  
                    <th class="has-text-centered " width="5%">
                      #
                    </th>
                    <th class="has-text-left " width="20%">
                      ຜູ້ຮັບຜິດຊອບ
                    </th>
                    <th class="has-text-right " width="20%">
                      ຈຳນວນເງິນ
                    </th>
                    <th class="has-text-centered " width="20%">
                      ເຕີມເງິນລ່າສຸດ
                    </th>
                    <th class="has-text-centered " width="20%">
                      ປະຫວັດ
                    </th>
                  
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in purchaserBalanceList"
                    :key="data.ID"
                  >
                    <td class="has-text-centered">
                      {{ index +1  }}
                      
                    </td>
                    <td class="has-text-left">
                      {{ data.NAME }}
                    </td>
                    <td class="has-text-right">
                      {{ data.BALANCE | formatNumberLocal }}
                    </td>
                    <td class="has-text-centered">
                      {{ data.LASTUPDATE }}
                    </td>
                    <td class="has-text-centered">
                      <b-button style="margin-top: 0px;"
                        class="btn-group-margin"
                        type="is-primary"
                        @click="getStatementHitstory(data.USERNAME, data.NAME)"
                        >ປະຫວັດການເຄື່ອນໄຫວ
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>

            </b-tab-item>
            <b-tab-item label="ປະຫວັດການເຄື່ອນໄຫວ">
              <b-field>
                ຜູ້ຮັບຜິດຊອບ: <span style="font-weight: bold;"> {{ selectedOwnerName }}</span>
              </b-field>
              <table class="table is-fullwidth is-narrow is-small">
                <thead>
                  <tr>
                  
                    <th class="has-text-centered " width="5%">
                      ລະຫັດ
                    </th>
                    <th class="has-text-centered " width="15%">
                      ວັນທີ
                    </th>
                    <th class="has-text-left " width="10%">
                      ຫົວຂໍ້
                    </th>
                    <th class="has-text-left " width="20%">
                      ເນື້ອໃນ
                    </th>
                    
                    <th class="has-text-right " width="15%">
                      ເງິນເຂົ້າ
                    </th>
                    <th class="has-text-right " width="15%">
                      ເງິນອອກ
                    </th>
                    <th class="has-text-right " width="15%">
                      ຍົກຍອດ
                    </th>
                    <th class="has-text-right " width="10%">
                      ລາຍລະອຽດ
                    </th>
                  
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data) in topupHistory"
                    :key="data.ID"
                  >
                    <td class="has-text-centered">
                      {{ data.ID  }}
                      
                    </td>
                    
                    <td class="has-text-centered">
                      {{ data.TXDATE}}
                    </td>
                    <td class="has-text-left">
                      {{ data.TITLE }}
                    </td>
                    <td class="has-text-left">
                      {{ data.REMARK }}
                    </td>
                    <td class="has-text-right">
                      {{ data.CREDIT | formatNumberLocal}}
                    </td>
                    <td class="has-text-right">
                      {{ data.DEBIT | formatNumberLocal}}
                    </td>
                    <td class="has-text-right">
                      {{ data.REMAIN | formatNumberLocal}}
                    </td>
                    <td class="has-text-right">
                      <b-button v-if="data.TYPEID !=1" style="margin-top: 0px;"
                        class="btn-group-margin"
                        type="is-primary"
                        @click="getStatementDetail(data.ID, data.TXDATE)"
                        >ລາຍລະອຽດ     
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab-item>
            <b-tab-item label="ປະຫວັດການຊື້ສິນຄ້າ">
              <b-field>
                ຜູ້ຮັບຜິດຊອບ: <span style="font-weight: bold;"> {{ selectedOwnerName }}</span>
              </b-field>
              <b-field>
                ວັນທີ: <span style="font-weight: bold;"> {{ selectedStatementTXDATE }}</span>
              </b-field>
              <table class="table is-fullwidth is-narrow is-small">
                <thead>
                  <tr>
                  
                    <th class="has-text-centered " width="5%">
                      #
                    </th>
                    <th class="has-text-centered " width="20%">
                      ສິນຄ້າ
                    </th>
                    <th class="has-text-right " width="20%">
                      ຈຳນວນ
                    </th>
                    <th class="has-text-right " width="20%">
                      ຈຳນວນ (ທີ່ຊື້ຕົວຈິງ)
                    </th>
                    
                    <th class="has-text-right " width="30%">
                      ຈຳນວນເງິນ
                    </th>
                  
                  
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in statementDetail"
                    :key="data.PRODUCTID"
                  >
                    <td class="has-text-centered">
                      {{ index + 1 }}
                    </td>
                    <td class="has-text-centered">
                      {{data.PRODUCTNAME }}<br>
                      <img
                        class="image-area"
                        style="width: 100%; max-width: 100px; "
                        :src="getImgUrl('products/' + data.PHOTONAME)"
                        
                      />  
                    </td>
                    <td class="has-text-right">
                      {{data.QUANTITY | formatNumberLocal }}
                    </td>
                    <td class="has-text-right">
                      {{data.MARKETQUANTITY | formatNumberLocal }}
                    </td>
                    <td class="has-text-right">
                      {{data.TOTALPRICE | formatNumberLocal}}<br>
                      {{ parseInt(data.TOTALPRICE / data.QUANTITY) | formatNumberLocal }}/ ກິໂລ <br>
                      {{ parseInt(data.TOTALPRICE / data.QUANTITY * 12)| formatNumberLocal }}/ ໝື່ນ
                    </td>
      
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th colspan="4" class="has-text-right">
                      ລວມ 
                    </th>
                    <th  class="has-text-right">
                      {{ _.sumBy(statementDetail, i => i["TOTALPRICE"]) | formatNumberLocal }}
                    </th>             
                  </tr>
                </tfoot>
              </table>
            </b-tab-item>
          </b-tabs>

         
   </div>
  
    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  components: {Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      activeTab: 0,
      photopath:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manager-mainv2/api/uploads/"
          // : "http://localhost/agrilao-manager/api/uploads/",
          : "https://agrilao.com/manager-main/api/uploads/",

      purchaserBalanceList: [],
      selectedPurchaser: [],
      selectedAmount: 0,
      topupHistory: [],
      selectedOwnerName: null,
      selectedStatementTXDATE: null,
      statementDetail: [],
    };
  },
  methods: {
    getStatementDetail(ID, TXDATE){
      this.selectedStatementTXDATE = TXDATE;
      this.activeTab = 2;
      RestAPI.getStatementDetail(ID)
        .then((res) => {
          this.statementDetail = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getStatementHitstoryByType(ownser, typeid) {
      RestAPI.getStatementHitstoryByType(ownser, typeid)
        .then((res) => {
          this.topupHistory = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getStatementHitstory (owner, ownername) {
      RestAPI.getStatementHitstory(owner)
        .then((res) => {
          this.selectedOwnerName = ownername;
          this.activeTab = 1;
          this.topupHistory = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    topupMoney(){ 

      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#FF3860",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {   
          var params = {
            purchaserid: this.selectedPurchaser.ID,
            amount: this.selectedAmount,
            remark: this.selectedRemark,
            username: this.username,
          };
          // console.log("params: " +JSON.stringify(params))
          RestAPI.topupMoney(params)
              .then(() => {
              this.getPurchaserBalance();
              this.selectedPurchaser = [];
              this.selectedAmount = 0;
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
        }
      });

    },
  
    getPurchaserBalance() {
      RestAPI.getPurchaserBalance()
        .then((res) => {
          this.purchaserBalanceList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    
    getImgUrl(photoname) {
      var photopreview = photoname
        ? this.photopath + photoname
        : this.photopath + "unknown.png";
      return photopreview;
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
    year(date) {
      return new moment(date).format("YYYY");
    },

    
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.getPurchaserBalance();


  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}

/* Style for the close button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from { -webkit-transform: scale(0); }
  to { -webkit-transform: scale(1); }
}

@keyframes zoom {
  from { transform: scale(0); }
  to { transform: scale(1); }
}

.text-right-input input {
  text-align: right;
}

.custom-align {
    text-align: right;
}
.asterisk {
  color: red;
}

.set-border {
  border: 1px solid #ddd;
}

/* .summary-footer {
  page-break-before: always;
} */

.modal {
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
